// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3mKTU5gvx{display:flex;flex-direction:column;width:100vw}._3mKTU5gvx ._1ROTpmtJx{display:flex;flex-direction:column;flex:1;justify-content:center;align-items:center}._3mKTU5gvx ._2Oav40ROx{text-align:center;display:flex;flex-direction:column;flex:5;justify-content:center;align-items:center}._3mKTU5gvx ._2Oav40ROx ._49WMzEXLx{margin:10px}._3mKTU5gvx ._2Oav40ROx .xzDAVwnax{color:#9C9C9C;font-size:14px}._3mKTU5gvx ._2Oav40ROx ._31WtB7UUx{color:#303030;font-size:16px;margin:3px}._3mKTU5gvx ._2Oav40ROx ._2cGXVb5ox{color:#9C9C9C;font-size:18px;margin:20px}._3mKTU5gvx ._2Oav40ROx ._3zhvb96jx{margin:10px}._3mKTU5gvx ._5TjYWOoOx{margin:20px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"not-found": "_3mKTU5gvx",
	"notFound": "_3mKTU5gvx",
	"logo": "_1ROTpmtJx",
	"content": "_2Oav40ROx",
	"gravatar": "_49WMzEXLx",
	"signed-in-as": "xzDAVwnax",
	"signedInAs": "xzDAVwnax",
	"email": "_31WtB7UUx",
	"error-message": "_2cGXVb5ox",
	"errorMessage": "_2cGXVb5ox",
	"sign-out": "_3zhvb96jx",
	"signOut": "_3zhvb96jx",
	"footer": "_5TjYWOoOx"
};
module.exports = exports;
